import React, {useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {changePageTitle} from "../typescript/redux/actions";
import {LaboratoryService} from "./laboratory.service";
import CustomTextField from "../typescript/custom-text-field/custom-text-field";
import CustomButton from "../typescript/custom-button/custom-button";
import CustomButtonGroup from "../typescript/custom-button-group/custom-button-group";

export function LaboratoryDetail({id, onClose, dialog}) {

    const [item, setItem] = useState(LaboratoryService.createLaboratory());
    const dispatch = useDispatch();

    const findOne = useCallback(async () => {
        const result = await LaboratoryService.findOne(id);
        setItem(result);
    }, [id]);

    useEffect(() => {
        if (!dialog) {
            dispatch(changePageTitle(id ? "Laboratório " + id : "Novo laboratório"));
        }
        if (id) {
            findOne().then();
        }
    }, [dispatch, findOne, id, dialog]);

    const save = (event) => {
        event.preventDefault();
        event.stopPropagation();
        LaboratoryService.save(item).then((result) => {
            onClose(result.data);
        }).catch(() => {

        })
    }

    const cancel = () => {
        onClose();
    }

    const setDescription = (event) => {
        setItem({
            ...item,
            description: event.target.value
        })
    }

    const setCnpj = (event) => {
        setItem({
            ...item,
            cnpj: event.target.value
        })
    }

    return (
        <form onSubmit={save}>
            <CustomTextField fullWidth autoFocus required label="Descrição" value={item.description}
                             onChange={setDescription}/>
            <CustomTextField fullWidth label="CNPJ" value={item.cnpj ?? ''} onChange={setCnpj}/>
            <CustomButtonGroup>
                <CustomButton color="primary" type="submit">Salvar</CustomButton>
                <CustomButton type="button" color="neutral" onClick={cancel}>Cancelar</CustomButton>
            </CustomButtonGroup>
        </form>
    )
}